import * as React from "react";
import HeaderLayoutDefault from "./Layouts/HeaderLayoutDefault";
import HeaderLayoutLeft from "./Layouts/HeaderLayoutLeft";
import HeaderLayoutCenter from "./Layouts/HeaderLayoutCenter";
import HeaderLayoutRight from "./Layouts/HeaderLayoutRight";
import HeaderSplit2RowLeft from "./Layouts/HeaderSplit2RowLeft";
import './Header.scss';
import {useEffect} from "react";
import headerMenuStore from "@src/stores/HeaderMenuStore";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { mobileBreakpoint } from "../../../../entrypoints/theme";

const Layouts = {
    'header-layout-left': HeaderLayoutLeft,                
    'header-split-2row-left': HeaderSplit2RowLeft,        
    'header-layout-center': HeaderLayoutCenter,        
    'header-layout-right': HeaderLayoutRight,
}

export const Header = ({ colorSchema, links, item_count = '', settings, type = 'left', show_search_bar = false}) => {
    const LayoutComponent = Layouts[type] || HeaderLayoutDefault;
    const { openMenu, toggleMenu, setupBodyClickListener } = headerMenuStore();
    const isMobile = useMobileBreakpoint(mobileBreakpoint);

    // useEffect(() => {
    //     // console.log('Header Init Body');
    //     setupBodyClickListener();
    // }, [setupBodyClickListener]);

    useEffect(() => {
        // Pass `isMobile` to the setupBodyClickListener function
        const cleanup = setupBodyClickListener(isMobile);

        // Clean up the listener when the component unmounts
        return () => {
            cleanup();
        };
    }, [setupBodyClickListener, isMobile]);

    return (
        <div x-init="$nextTick(() => { $store.navigation.init() })">
            <LayoutComponent
                settings={settings}
                links={links}
                item_count={item_count}
            />
        </div>
    );
};

